export const MAX_STRIPE_AMOUNT = 99999999;
